import { ReactNode } from "react"
import { Tooltip } from "antd"

type Props = {
    column: string
    order: string
    current: string
    text?: string
    children: ReactNode
    startOrder: "descending" | "ascending"
}

export function SortTooltip({ order, column, current, children, startOrder = "descending", text = "Click to sort" }: Props) {
    const active = current === column
    const secondOrder = startOrder === "descending" ? "ascending" : "descending"
    const dir = active ? (order === "ascend" ? startOrder : secondOrder) : startOrder
    const title = `${text} ${dir}`
    return (
        <Tooltip placement="top" title={title}>
            {children}
        </Tooltip>
    )
}
